// Utility function to capitalize the first letter of a string
export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// Utility function to capitalize the first letter of a string in every word of the string
export const capitalizeFirstLetterInEveryWord = (str: string) => {
  return str.split(' ').map(capitalizeFirstLetter).join(' ')
}
